/*
 * Copyright (c) 2026. Tooling Team
 */

import { Tooltip } from "@uhg-abyss/web/ui/Tooltip";

const PRODUCT_USAGE_STYLES = {
  VC: {
    backgroundColor: "#002677",
    color: "#ffffff",
    border: "none",
  },
  LS: {
    backgroundColor: "#D9F6FA",
    color: "#002677",
    border: "1px solid #002677",
  },
  CAI: {
    backgroundColor: "#ffffff",
    color: "#002677",
    border: "1px solid #002677",
  },
};

const CIRCLE_BASE_STYLE = {
  alignItems: "center",
  borderRadius: "50%",
  boxSizing: "border-box",
  display: "inline-flex",
  fontSize: "9px",
  fontWeight: 700,
  height: "31px",
  justifyContent: "center",
  letterSpacing: "0.02em",
  width: "31px",
};

const CELL_CONTAINER_STYLE = {
  alignItems: "center",
  display: "flex",
  gap: "4px",
};

const TOOLTIP_CONTENT = (
  <div>
    <div>Optum product(s) in which this code is currently used.</div>
    <div>
      <strong>VC</strong> = ValueConnect
    </div>
    <div>
      <strong>LS</strong> = Optum Life Sciences
    </div>
    <div>
      <strong>CAI</strong> = Crimson AI
    </div>
  </div>
);

const ProductUsageCell = (cell) => {
  const values = cell.getValue?.() ?? [];

  return (
    <Tooltip content={TOOLTIP_CONTENT} asChild={false}>
      <div style={CELL_CONTAINER_STYLE} data-testid="product-usage-circles">
        {values.map((label) => (
          <span
            key={label}
            style={{ ...CIRCLE_BASE_STYLE, ...PRODUCT_USAGE_STYLES[label] }}
          >
            {label}
          </span>
        ))}
      </div>
    </Tooltip>
  );
};

export default ProductUsageCell;
